module.exports = __webpack_public_path__ + "img/img_home_banner@__2x (1).e267063.png";